import { useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { saveUserAction } from "@twire/redux/track/actions";
import { pptPageView } from "@twire/redux/track/userActions/userActions";
import { useDispatch } from "react-redux";
import Ppt from "./Ppt";

const PptsContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { url } = useRouteMatch();

  useEffect(() => {
    dispatch(saveUserAction(pptPageView()));
  }, []);
  return <Ppt url={url} />;
};

export default PptsContainer;
